import * as React from "react";
import type { GatsbyBrowser } from "gatsby";

// Inter — self-hosted (GDPR + performance, docs/DECISIONS.md D018).
// Weights must match docs/BRAND_GUIDELINES.md: 400/500/600/700.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

// Import global styles
import "./src/styles/global.css";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => {
  return <>{element}</>;
};

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const scrollToHash = (hash: string, smooth: boolean) => {
  if (!hash || hash === "#") return;
  const element = document.querySelector(hash);
  if (!(element instanceof HTMLElement)) return;
  element.scrollIntoView({
    behavior: smooth && !prefersReducedMotion() ? "smooth" : "auto",
    block: "start",
  });
};

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  if (typeof history !== "undefined" && "scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
};

/** First paint must be the top of the page unless the URL has an anchor. */
export const onInitialClientRender: GatsbyBrowser["onInitialClientRender"] =
  () => {
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
  };

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.hash) {
    return false;
  }
  const saved = getSavedScrollPosition(location);
  return saved || [0, 0];
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  if (location.hash) {
    window.setTimeout(() => scrollToHash(location.hash, true), 80);
  }
};
